import React, { useEffect, useState } from "react";
import { AudioTile } from "./components/AudioTile";
import {
  Text,
  Dropdown,
  Option
} from "@salt-ds/core";

type Driver = {
  session_key: string;
  meeting_key: string;
  driver_number: number;
  broadcast_name: string;
  team_colour: string;
};

type Radio = {
  driver_number: string;
  date: string;
  recording_url: string;
};

type Lap = {
  date_start: string;
  driver_number: number;
  lap_number: string;
};

const Getsessionkey = () => {
  const [years, setYears] = useState<string[]>([]);
  const [locations, setLocations] = useState<string[]>([]);
  const [sessions, setSessions] = useState<string[]>([]);

  const [selectedYear, setSelectedYear] = useState<string>();
  const [selectedLocation, setSelectedLocation] = useState<string>();
  const [selectedSession, setSelectedSession] = useState<string>();

  const [meetingKey, setMeetingKey] = useState<string>();
  const [sessionKey, setSessionKey] = useState<string>();

  const [radios, setRadios] = useState<Radio[]>([]);
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [laps, setLaps] = useState<Lap[]>([]);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const response = await fetch("https://api.openf1.org/v1/meetings?");
        const data = await response.json();
        const yearsArr: string[] = Array.from(
          new Set(data.map((item: any) => item.year.toString()))
        );
        setYears(yearsArr);
      } catch (error) {
        console.log("error fetching years", error);
      }
    };
    fetchYears();
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/meetings?year=${selectedYear}`
        );
        const data = await response.json();
        const locationsArr: string[] = Array.from(
          new Set(data.map((item: any) => item.meeting_name.toString()))
        );
        setLocations(locationsArr);
      } catch (error) {
        console.log("error fetching events", error);
      }
    };
    fetchEvents();
  }, [selectedYear]);

  useEffect(() => {
    if (!selectedLocation || !selectedYear) return;
    const fetchMeetingKey = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/meetings?year=${selectedYear}&meeting_name=${selectedLocation}`
        );
        const data = await response.json();
        if (data && data.length > 0) {
          setMeetingKey(data[0].meeting_key);
        } else {
          setMeetingKey(undefined);
          console.log("No meeting key found for this selection.");
        }
      } catch (error) {
        console.log("error fetching meeting key", error);
      }
    };
    fetchMeetingKey();
  }, [selectedYear, selectedLocation]);

  useEffect(() => {
    if (!meetingKey) return;
    const fetchSessions = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/sessions?meeting_key=${meetingKey}`
        );
        const data = await response.json();
        const sessionsArr: string[] = Array.from(
          new Set(data.map((item: any) => item.session_name.toString()))
        );
        setSessions(sessionsArr);
      } catch (error) {
        console.log("error fetching sessions", error);
      }
    };
    fetchSessions();
  }, [meetingKey]);

  useEffect(() => {
    if (!meetingKey || !selectedLocation) return;
    const fetchSessionKey = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/sessions?meeting_key=${meetingKey}&session_name=${selectedSession}`
        );
        const data = await response.json();
        if (data && data.length > 0) {
          setSessionKey(data[0].session_key);
        } else {
          setSessionKey(undefined);
          console.log("No session key found for this selection.");
        }
      } catch (error) {
        console.log("error fetching session key", error);
      }
    };
    fetchSessionKey();
  }, [meetingKey, selectedSession, selectedLocation]);

  useEffect(() => {
    if (!sessionKey) return;

    const fetchRadios = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/team_radio?session_key=${sessionKey}`
        );
        const data = await response.json();
        setRadios(data);
      } catch (error) {
        console.log("error fetching team radios", error);
      }
    };
    fetchRadios();
  }, [sessionKey]);

  useEffect(() => {
    if (!sessionKey) return;

    const fetchDrivers = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/drivers?session_key=${sessionKey}`
        );
        const data = await response.json();
        setDrivers(data);
      } catch (error) {
        console.log("error fetching drivers", error);
      }
    };
    fetchDrivers();
  }, [sessionKey]);

  useEffect(() => {
    if (
      !sessionKey ||
      (selectedSession !== "Race" && selectedSession !== "Sprint")
    )
      return;

    const fetchLaps = async () => {
      try {
        const response = await fetch(
          `https://api.openf1.org/v1/laps?session_key=${sessionKey}`
        );
        const data = await response.json();
        setLaps(data);
      } catch (error) {
        console.log("error fetching lap info", error);
      }
    };
    fetchLaps();
  }, [sessionKey, selectedSession]);

  return (
    <div>
      <Text styleAs="h1">Team Radio F1</Text>
      <br />
      <br />
      <Text styleAs="label">Select Year:</Text>
      <Dropdown
        onSelectionChange={(_event, x) => setSelectedYear(x[0])}
        value={selectedYear}
      >
        {years.map((year) => (
          <Option key={year} value={year}>
            {year}
          </Option>
        ))}
      </Dropdown>

      <br />
      <br />
      <Text styleAs="label">Select Grand Prix</Text>
      <Dropdown
        onSelectionChange={(_event, x) => setSelectedLocation(x[0])}
        value={selectedLocation}
      >
        {locations.map((location) => (
          <Option key={location} value={location}>
            {location}
          </Option>
        ))}
      </Dropdown>

      <br />
      <br />
      <Text styleAs="label">Select Session</Text>
      <Dropdown
        onSelectionChange={(_event, x) => setSelectedSession(x[0])}
        value={selectedSession}
      >
        {sessions.map((session) => (
          <Option key={session} value={session}>
            {session}
          </Option>
        ))}
      </Dropdown>

      <br />
      <br />
      <br />

      {radios.length === 0 && <h2>No radios to display</h2>}

      {radios.length > 0 && (
        <div>
          {radios.map((radio: any, idx: number) => {
            const driver = drivers.find(
              (d: any) => d.driver_number === radio.driver_number
            );

            let lapNumber: string | number = "";
            if (selectedSession === "Race" || selectedSession === "Sprint") {
              const driverLaps = laps.filter(
                (lap: any) => lap.driver_number === radio.driver_number
              );
              const radioDate = new Date(radio.date).getTime();
              const exactLap = driverLaps.find(
                (lap: any) => lap.date_start === radio.date
              );
              if (exactLap) {
                lapNumber = exactLap.lap_number;
              } else {
                const lapsBeforeRadio = driverLaps
                  .filter(
                    (lap: any) =>
                      lap.date_start &&
                      new Date(lap.date_start).getTime() <= radioDate
                  )
                  .sort(
                    (a: any, b: any) =>
                      new Date(b.date_start).getTime() -
                      new Date(a.date_start).getTime()
                  );
                if (lapsBeforeRadio.length > 0) {
                  lapNumber = lapsBeforeRadio[0].lap_number;
                } else {
                  const firstLap = driverLaps
                    .filter((lap: any) => lap.lap_number >= 1 && lap.date_start)
                    .sort(
                      (a: any, b: any) =>
                        new Date(a.date_start).getTime() -
                        new Date(b.date_start).getTime()
                    )[0];
                  if (
                    firstLap &&
                    radioDate < new Date(firstLap.date_start).getTime()
                  ) {
                    lapNumber = "Prior To Race Start";
                  } else {
                    const lastLap = driverLaps
                      .filter((lap: any) => lap.date_start)
                      .sort(
                        (a: any, b: any) =>
                          new Date(b.date_start).getTime() -
                          new Date(a.date_start).getTime()
                      )[0];
                    if (
                      lastLap &&
                      radioDate > new Date(lastLap.date_start).getTime()
                    ) {
                      lapNumber = "post race";
                    }
                  }
                }
              }
            }

            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1em",
                }}
              >
                
                {(driver && radio) ? (
                  <AudioTile
                    driverNumber={radio.driver_number}
                    driverName={driver.broadcast_name}
                    link={radio.recording_url}
                    lap={lapNumber}
                    colour={driver.team_colour}
                  />
                ) : (
                  <span>Unknown driver for radio #{radio.driver_number}</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Getsessionkey;
